import MyIcon from 'components/Icon';
import React, { Component } from 'react';
/*
    // 22/03/2018

    Retornos da API:

    1   Entrou no Redirect
    2   Abriu o Carrinho
    3   Clicou em Pagar
    4   Iniciou o Pagamento
    5   Requisitou o Gateway
    6   Chegou na Tela de Obrigado
    7   Retorno Gateway
    8   Clicou no link do Afiliado e saiu da Recuperação
    9   Clicou no e-mail de recuperaçao
    10  Afiliado removeu o pedido da Recuperação
    11  Fatura de recorrencia criada
    12  Assinatura Atrasada
    13  Assinatura Suspensa
    14  Assinatura Ativa
    15  Clicou no e-mail de recuperação (Abandono de Carrinho)
    16  Clicou em campanha de remarketing (Facebook)
    17  Boleto Processado
    18  Lançado o reembolso no Extrato financeiro
    19  Ação de Recuperação
    20  Entrou em recuperação
    21  Feito pedido de reembolso
    22  Pagamento processado pelo Gateway de Backup
    23  Status da fatura alterado para Em Recuperação
    24  Cancelamento do pedido de reembolso
    25  Iniciou Período Trial
    26  Reemissão do boleto
    27  Inseriu cupom de desconto
    28  Sistema de Entrega recebeu os dados para a entrega
    29  Sistema de Entrega retornou uma falha ao receber os dados para a entrega
    30  Entrega WebHook
    31  Lembre de pagamento do boleto da assinatura
    32  Chargeback solicitado
    33  Chargeback efetuado
    34  Chargeback revertido
    35  Sistema de Entrega - Acesso removido com Sucesso
    36  Sistema de Entrega - Retornou um Erro ao remover o acesso do usuário
    37  Observação
    38  Inseriu afiliado manualmente
    39  Estornou reembolso
    40  Novo boleto gerado - Assinatura
    41  Chargeback reversível
    42  Chargeback - documentos enviados
    43  Chargeback - e-mail solicitando documentos foi enviado
    44  Feito pedido de reembolso - sem taxa
    45  Fatura cancelada
*/
/*
    Icons:

    cart open: icon-history-open-cart
    payment PSP: icon-history-payment-psp
    attempt recovery: icon-history-attempt-recovery
    approved purchase: icon-history-approved-purchase
    delivery nutror: icon-history-delivery-nutror
    credit card: icon-history-credit-card
    reembolsado: icon-history-chargeback
    recuperacao: icon-history-recuperation
    entrega: icon-history-delivery
    pagamento: icon-history-approved-purchase
    generico: icon-history-any

*/

interface IProps {
  icon: number;
}

class HistoryIcon extends Component<IProps, any> {
  renderSwitch(icon: number) {
    switch (icon) {
      case 2:
        return 'icon-history-open-cart';
      case 20:
      case 8:
      case 9:
      case 15:
      case 19:
      case 23:
        return 'icon-history-recuperation';
      case 18:
      case 21:
      case 24:
      case 39:
      case 44:
        return 'icon-history-chargeback';
      case 28:
      case 29:
      case 30:
      case 35:
      case 36:
        return 'icon-history-delivery';
      case 6:
        return 'icon-history-approved-purchase';
      default:
        return 'icon-history-any';
    }
  }
  render() {
    return <MyIcon name={this.renderSwitch(this.props.icon)} />;
  }
}
export default HistoryIcon;
